module.exports = __webpack_public_path__ + "images/areamap/btn_mappin_kanto_pc_13110f22e4e59abf0ca1ded6777c8360.png";